import React from 'react';
import classNames from 'classnames';
import { codes } from '../../../../../../ReactSharedScripts/data/translations';
import HeaderLogo from '../../../../../../ReactSharedScripts/modules/header/components/HeaderLogo';
import classes from '../../styles/index.module.scss';
import PaddingBox from '../../../../../../ReactSharedScripts/components/PaddingBox';
import HeaderListPageSection from '../HeaderListPageSection';
import HeaderUserTooltip from '../HeaderUserTooltip';
import { headerPropTypes } from '../../../../../../ReactSharedScripts/modules/header/const';
import HeaderGeneralLanguages from '../../../../../../ReactSharedScripts/modules/header/components/HeaderGeneralLanguages';
import { generalClasses } from '../../../../../../ReactSharedScripts/utils/const';
import HeaderUserSectionClockLoading from '../../../../../../ReactSharedScripts/modules/header/components/HeaderClockLoading';
import FlexGrid, {
	FlexGridColumn,
} from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { LOGIN_URL } from '../../../../../../ReactSharedScripts/modules/user';
import { hasToolNavigation } from '../../../../../../ReactSharedScripts/modules/toolNavigation_new/hasToolNavigation';
import { useTranslationAPI } from '../../../../../../ReactSharedScripts/modules/translations';
import RouteLink from '../../../../../../ReactSharedScripts/components/RouteLink';

const HeaderLayout = ({
	isLoginPage,
	hasActivePositionOverlay,
	hasExpandedSidebar,
	headerHasExpandedView,
	headerHasCollapsedView,
	isListPage,
	showUserMenu,
	showLoginPageLanguages,
	showLoginButton,
	showSpinner,
	headerInlineStyles,
	showFullName,
	showEndSessionButton,
	handlePublicDocumentListLogout,
}) => {
	const { translate } = useTranslationAPI();
	const headerClasses = classNames('js--page-header', classes.header, generalClasses.fixedSection, {
		[classes.header_hasActivePositionOverlay]: hasActivePositionOverlay,
		[classes.header_expandedSidebar]: hasExpandedSidebar && isListPage,
		[classes.header_collapsedToolNav]: hasToolNavigation() && headerHasCollapsedView,
		[classes.header_expandedToolNav]: hasToolNavigation() && headerHasExpandedView,
	});

	return (
		<FlexGrid
			className={headerClasses}
			center
			spaceBetween
			style={headerInlineStyles}
		>
			<FlexGridColumn>
				<PaddingBox rightSmall>
					<HeaderLogo />
				</PaddingBox>
			</FlexGridColumn>
			<FlexGridColumn grow>
				<FlexGrid
					hrEnd
					center
				>
					{isListPage && (
						<FlexGridColumn grow>
							<HeaderListPageSection />
						</FlexGridColumn>
					)}
					{showUserMenu && (
						<FlexGridColumn>
							<HeaderUserTooltip showFullName={showFullName} />
						</FlexGridColumn>
					)}
					{showSpinner && <HeaderUserSectionClockLoading />}
					{showLoginPageLanguages && (
						<FlexGridColumn>
							<PaddingBox leftSmall>
								<HeaderGeneralLanguages isLoginPage={isLoginPage} />
							</PaddingBox>
						</FlexGridColumn>
					)}
					{showLoginButton && (
						<FlexGridColumn>
							<PaddingBox leftSmall>
								<RouteLink
									styledButton
									primary
									href={LOGIN_URL}
									size='small'
									hasColor={false}
								>
									{translate(codes.logIn)}
								</RouteLink>
							</PaddingBox>
						</FlexGridColumn>
					)}
					{showEndSessionButton && (
						<FlexGridColumn>
							<PaddingBox leftSmall>
								<RouteLink
									styledButton
									primary
									onClick={handlePublicDocumentListLogout}
									size='small'
									hasColor={false}
								>
									{translate(codes.endSession)}
								</RouteLink>
							</PaddingBox>
						</FlexGridColumn>
					)}
				</FlexGrid>
			</FlexGridColumn>
		</FlexGrid>
	);
};

HeaderLayout.propTypes = {
	...headerPropTypes,
};

export default HeaderLayout;
